/**
 * Crawler, druhý nástroj v portálu vedle oceňovací kalkulačky. Jen pro adminy.
 *
 * Aplikace běží mimo tenhle portál (Streamlit na vlastním serveru), proto se
 * sem nedá jen tak vykreslit. Otevírá se v nové záložce.
 */
import React from 'react';

const ACCENT = 'var(--purple-glow)';

// Adresa nástroje. Až dostane vlastní hostname (crawll.mnai.cz), stačí přepsat tady.
const CRAWLER_URL = 'https://46.62.232.35.sslip.io/';

// Vložení do stránky přes iframe zatím nejde: server posílá hlavičku
// X-Frame-Options: SAMEORIGIN a prohlížeč rámec odmítne vykreslit. Až ji
// správce serveru nahradí za Content-Security-Policy frame-ancestors
// s doménou mnai.cz, přepni tenhle přepínač na true.
const VLOZIT_DO_STRANKY = false;

export function Crawler() {
  return (
    <div style={{ maxWidth: 980, margin: '0 auto', padding: '2rem 1rem', fontFamily: "'Inter', sans-serif" }}>

      <div style={{ fontSize: '0.78rem', color: ACCENT, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
        Interní nástroj
      </div>
      <h1 style={{ margin: '0 0 0.5rem', fontFamily: "'Source Serif 4', Georgia, serif", color: 'var(--star-white)', fontSize: '1.9rem', lineHeight: 1.15 }}>
        Crawler
      </h1>
      <p style={{ color: 'var(--text-dim)', fontSize: '1rem', lineHeight: 1.55, maxWidth: 580, margin: '0 0 1.5rem' }}>
        Nástroj běží na vlastním serveru mimo portál. Otevře se v nové záložce,
        portál zůstane otevřený tady.
      </p>

      {VLOZIT_DO_STRANKY ? (
        <iframe
          src={CRAWLER_URL}
          title="Crawler"
          style={{ width: '100%', height: '78vh', border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, background: 'var(--purple-dark)' }}
        />
      ) : (
        <>
          <a
            href={CRAWLER_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block', background: ACCENT, color: '#fff', textDecoration: 'none',
              fontWeight: 700, fontSize: '0.95rem', padding: '0.8rem 1.4rem', borderRadius: 8,
            }}
          >
            Otevřít Crawler →
          </a>
          <div style={{ fontSize: '0.85rem', color: 'var(--text-dim)', marginTop: '1.25rem', lineHeight: 1.55, maxWidth: 580 }}>
            Adresa nástroje je zatím dočasná a kdo ji zná, otevře ji i bez přihlášení do portálu.
            Tahle položka menu ji jen schovává před klienty, nechrání ji.
          </div>
        </>
      )}
    </div>
  );
}
